export const fmtUsd = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  if (n >= 1_000_000_000) return `$${(n / 1_000_000_000).toFixed(2)}B`;
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(2)}M`;
  if (n >= 1_000) return `$${(n / 1_000).toFixed(1)}K`;
  return `$${n.toFixed(2)}`;
};

export const fmtPrice = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  if (n === 0) return "$0";
  if (n >= 1) return `$${n.toFixed(4)}`;
  if (n >= 0.0001) return `$${n.toFixed(6)}`;
  // subscript-style small numbers
  const str = n.toFixed(12).replace(/0+$/, "");
  return `$${str}`;
};

export const fmtPct = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const s = n > 0 ? "+" : "";
  return `${s}${n.toFixed(1)}%`;
};

export const fmtAge = (hours) => {
  if (hours === null || hours === undefined) return "—";
  if (hours < 1) return `${Math.round(hours * 60)}m`;
  if (hours < 24) return `${Math.round(hours)}h`;
  const d = hours / 24;
  if (d < 30) return `${Math.round(d)}d`;
  return `${Math.round(d / 30)}mo`;
};

export const scoreColor = (score) => {
  if (score >= 70) return "#00E599";
  if (score >= 45) return "#F5A623";
  return "#FF3366";
};

export const changeColor = (n) => (n >= 0 ? "#00E599" : "#FF3366");
